<template>
    <div>
        <div v-for="(i, index) in allInsts">
            <expression-atom :ref="`atom${index+1}`" :name="`式${index+1}`" :variables="fields" :instances="providedInsts[index]" @alter="alterInst($event, index)"></expression-atom>
            <expression-note :instance="i" mode="code" prefix="MYSQL: "></expression-note>
<!--            <expression-note :instance="i" mode="display" prefix="说明: "></expression-note>-->
        </div>
    </div>
</template>

<script>

    import ExpressionAtom from '../../mould-v/clause/ExpressionAtom'
    import ExpressionNote from '../../mould-v/explain/ExpressionNote'
    import { OP, Template, Parameter, Instance, Table, Field, Enum, Operators, i18n, DATUM, Metadata } from '../../mould';

    export default {

        name: 'demo-keynote',

        components: {ExpressionAtom, ExpressionNote},

        data(){
            return {
                fields: [],
                allInsts: [null, null, null, null],
                providedInsts: [],
                added: false
            }
        },

        async mounted(){


            i18n.switchTo('cn');
            Operators.activateContext('mysql');
            Metadata.clear()

            let allData = [
                new Table({
                    name: 'A',
                    label: '观影事实表'
                }).addFields([
                    new Field({
                        name: 'END_TIME',
                        label: '结束时间',
                        dataType: 'number'
                    }),
                    new Field({
                        name: 'START_TIME',
                        label: '开始时间',
                        dataType: 'number'
                    })
                ]),

                new Table({
                    name: 'B',
                    label: '用户维表'
                }).addFields([
                    new Field({
                        name: 'SIGNUP_TIME',
                        label: '注册时间',
                        dataType: 'number'
                    })
                ])
            ];

            this.fields = [];
            allData.forEach(t => {
                this.fields.push(...t.getFields());
            })


            let inst1 = new Instance({template: OP('-')});
            inst1.setValue('$1', DATUM('A', 'END_TIME')).setValue('$2', DATUM('A', 'START_TIME'));
            inst1.name = '式1';

            this.$refs.atom1[0].syncInstance(inst1);
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        let inst2 = new Instance({template: OP('sum')});
                        inst2.setValue('$1', this.$refs.atom1[0].instance);
                        inst2.name = '式2';
                        let inst3 = new Instance({template: OP('-')});
                        inst3.setValue('$1', 1555000000).setValue('$2', DATUM('B', 'SIGNUP_TIME'));
                        inst3.name = '式3';
                        this.$refs.atom2[0].syncInstance(inst2);
                        this.$refs.atom3[0].syncInstance(inst3);
                        this.$nextTick(() => {
                            this.$nextTick(() => {
                                this.$nextTick(() => {
                                    let inst4 = new Instance({template: OP('/')});
                                    inst4.setValue('$1', this.$refs.atom2[0].instance).setValue('$2', this.$refs.atom3[0].instance);
                                    inst4.name = '式';
                                    this.$refs.atom4[0].syncInstance(inst4);
                                })
                            })
                        })
                    })
                })
            })


        },

        methods: {

            alterInst(inst, index){
                this.allInsts[index] = inst;
                this.updateProvided();
            },

            addInst(){
                this.allInsts.push(null);
                this.updateProvided();
            },

            updateProvided(){
                this.$nextTick(() => {
                    let arr = [];
                    let len = this.allInsts.length;
                    this.allInsts.forEach((i, index) => {
                        arr.push(this.allInsts.slice(0, index));
                    });
                    this.providedInsts = arr;
                });
            }
        },

        watch: {


        }
    }
</script>

<style scoped>

</style>